<template>
  <div class="quotas__item" :class="{ended: quota < 1}">
    <VProgressCircular
      :color="color"
      :size="$vuetify.breakpoint.xs ? 72 : ($vuetify.breakpoint.mdAndDown ? 86 : 100)"
      :value="percent"
      class="quotas__item-number-wrap"
    >
      <div>
        <div class="quotas__item-number">
          {{ quota }}
        </div>
        <div v-if="fullQuota !== 0" class="quotas__item-number-from">
          {{ $t('from') }} {{ fullQuota }}
        </div>
      </div>
    </VProgressCircular>
    <div class="quotas__item-name">
      <svg
        class="quotas__icon-ended"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M1 21H23L12 2L1 21ZM13 18H11V16H13V18ZM13 14H11V10H13V14Z" fill="#FF0000" />
      </svg>
      {{ $t(itemType) }}
      <!--      TODO: Убрать && false когда квоты будут готовы к тестам #ADD_QUOTA-->
      <RouterLink
        v-if="checkIfQuotaCanBeAdded(itemType) && false"
        style="margin-left: 10px;"
        :to="`/order/quota/${itemType}`"
      >
        {{ $t('add') }}
      </RouterLink>
    </div>
  </div>
</template>

<script>

import useAccount from '@/compositions/accounting/useAccount';
import { computed, toRefs } from '@vue/composition-api';
import { quotaTypes } from '@/enums';

export default {
  name: 'PlanQuotaItem',
  props: {
    quota: {
      type: Number,
      required: true,
    },
    itemType: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const { itemType, quota } = toRefs(props);
    const { plan, checkIfQuotaCanBeAdded } = useAccount();

    const fullQuota = computed(() => {
      const quotaData = plan.value.quotas.find((q) => q.itemType === itemType.value && q.type === quotaTypes.TEMP);
      return quotaData?.value || 0;
    });

    const percent = computed(() => Math.ceil((quota.value / fullQuota?.value) * 100));
    const color = computed(() => {
      if (percent.value > 50) {
        return 'green';
      }
      if (percent.value <= 50 && percent.value > 25) {
        return 'yellow';
      }
      return 'red';
    });

    return {
      fullQuota,
      plan,
      percent: percent.value > 100 ? 100 : percent,
      color,
      checkIfQuotaCanBeAdded,
    };
  },
};
</script>

<style lang="scss" scoped>
.quotas {
  &__item {
    flex-grow: 1;
    text-align: center;
    font-weight: 400;
    &:nth-child(2) {
      margin: 0 1.25rem;
    }
    &.ended {
      .quotas__icon-ended {
        display: inline-block;
      }
      .quotas__item-number-wrap {
        color: #FF0000;
        border-color: rgb(0 0 0 / 20%);
      }
    }
    &.few {
      .quotas__item-number-wrap {
        border-color: #FE8630;
      }
    }
  }
  &__item-number-wrap {
    margin-bottom: 1rem;
  }
  &__item-number {
    font-size: 1.5rem;
    line-height: 22px;
    letter-spacing: -0.04em;
    margin-bottom: 0.25rem;
  }
  &__item-number-from {
    font-size: 0.875rem;
    color: #757575;
  }
  &__item-name {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    height: 1.5rem;
    line-height: 1.375;
  }
  &__icon-ended {
    display: none;
    vertical-align: middle;
    margin-right: 0.25rem;
  }
}

@media #{map-get($display-breakpoints, 'md-and-down')} {
  .quotas {
    &__item-number {
      font-size: 1.25rem;
      margin-bottom: 0.125rem;
    }
    &__item-number-wrap {
      margin-bottom: 0.875rem;
    }
    &__item-number-from {
      font-size: 0.75rem;
    }
    &__item.ended .quotas__icon-ended {
      margin-right: 0.125rem;
      width: 1.125rem;
    }
  }
}

@media #{map-get($display-breakpoints, 'xs-only')} {
  .quotas {
    &__item:nth-child(2) {
      margin: 0 0.75rem;
    }
    &__item-number {
      font-size: 1.125rem;
      letter-spacing: -0.04em;
      margin-bottom: 0;
    }
    &__item-number-wrap {
      margin-bottom: 0.625rem;
    }
    &__item-number-from {
      font-size: 0.625rem;
    }
    &__item-name {
      font-size: 0.8125rem;
    }
    &__item.ended .quotas__icon-ended {
      margin-right: 0.125rem;
      width: 1.125rem;
    }
  }
}
</style>

<i18n locale="ru" lang="yml">
  interviews: Отклики
  sms: SMS
  calls: Звонки
  from: из
  add: Пополнить
</i18n>

<i18n locale="en" lang="yml">
  interviews: Interviews
  sms: Text messages
  calls: Calls
  from: out of
  add: Add
</i18n>
